export function toTitleCase(string: string) {
  return string
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim()
    .toLowerCase()
    .replace(/^[-_]*(.)/, (_, c: string) => c.toUpperCase())
    .replace(/[-_]+(.)/g, (_, c: string) => ` ${c.toUpperCase()}`)
    .replace(/\s([a-z])/g, (_, c: string) => ` ${c.toUpperCase()}`)
}
